var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuUploadGrades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6375 20.1698L22.4307 9.3765L21.236 8.18175L11.6375 17.7803L6.82812 12.9709L5.63337 14.1656L11.6375 20.1698ZM3.22531 27.75C2.44906 27.75 1.80106 27.4901 1.28131 26.9704C0.760437 26.4495 0.5 25.8009 0.5 25.0247V3.47531C0.5 2.69906 0.760437 2.05106 1.28131 1.53131C1.80106 1.01044 2.44906 0.75 3.22531 0.75H24.7747C25.5509 0.75 26.1989 1.01044 26.7187 1.53131C27.2396 2.05106 27.5 2.69906 27.5 3.47531V25.0247C27.5 25.8009 27.2401 26.4489 26.7204 26.9687C26.1995 27.4896 25.5509 27.75 24.7747 27.75H3.22531ZM3.22531 26.0625H24.7747C25.0334 26.0625 25.2714 25.9545 25.4885 25.7385C25.7045 25.5214 25.8125 25.2834 25.8125 25.0247V3.47531C25.8125 3.21656 25.7045 2.97862 25.4885 2.7615C25.2714 2.5455 25.0334 2.4375 24.7747 2.4375H3.22531C2.96656 2.4375 2.72862 2.5455 2.5115 2.7615C2.2955 2.97862 2.1875 3.21656 2.1875 3.47531V25.0247C2.1875 25.2834 2.2955 25.5214 2.5115 25.7385C2.72862 25.9545 2.96656 26.0625 3.22531 26.0625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUploadGrades);
export default __webpack_public_path__ + "static/media/menu-upload-grades.1bc35cbf319035dd32819c6fe4ec46d5.svg";
export { ForwardRef as ReactComponent };